'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactBootstrap = require('react-bootstrap');

var _lodash = require('lodash.values');

var _lodash2 = _interopRequireDefault(_lodash);

var _components = require('components');

var _reactRadioGroup = require('react-radio-group');

var _currencies = require('../../helpers/currencies');

var _currencies2 = _interopRequireDefault(_currencies);

var _validate = require('../../helpers/validate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var constants = {
  NULL: null,
  FREE: 'FREE',
  FIXED: 'FIXED',
  DONATION: 'DONATION'
};

var PriceBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(PriceBox, _Component);

  function PriceBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PriceBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PriceBox.__proto__ || (0, _getPrototypeOf2.default)(PriceBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      overlayOpen: false,
      type: _this.props.type,
      original_type: _this.props.type,
      prices: _this.props.prices.length ? _this.props.prices : [PriceBox.priceModel()],
      currency: _this.props.currency,
      currencyLabel: _currencies2.default[_this.props.currency] + ' (' + _this.props.currency + ')',
      notes: _this.props.notes,
      ticketUrl: _this.props.ticketUrl
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PriceBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps !== this.props) {
        this.setState({
          type: nextProps.type,
          original_type: this.props.type,
          prices: nextProps.prices.length ? nextProps.prices : [PriceBox.priceModel()],
          currency: nextProps.currency,
          notes: nextProps.notes,
          ticketUrl: nextProps.ticketUrl
        });
      }
    }
  }, {
    key: 'getTabUIFor',
    value: function getTabUIFor(kind) {
      var _state = this.state,
          prices = _state.prices,
          currency = _state.currency;

      var UI = '';

      switch (kind) {
        case constants.FIXED:
          UI = _react2.default.createElement(PriceBox.FixedTabContent, {
            prices: prices,
            currency: currency,
            handleChangeCurrency: this.handleChangeCurrency.bind(this),
            handleChangePrice: this.handleChangePrice.bind(this),
            handleAddPrice: this.handleAddPrice.bind(this),
            handleRemovePrice: this.handleRemovePrice.bind(this),
            polyglot: this.props.polyglot
          });
          break;
        case constants.DONATION:
          UI = _react2.default.createElement(PriceBox.DonationTabContent, {
            prices: prices,
            currency: currency,
            handleChangeCurrency: this.handleChangeCurrency.bind(this),
            handleChangePrice: this.handleChangePrice.bind(this),
            polyglot: this.props.polyglot
          });
          break;
        default:
          UI = _react2.default.createElement(PriceBox.FreeTabContent, null);
      }

      return UI;
    }
  }, {
    key: 'handleAddPrice',
    value: function handleAddPrice() {
      var prices = this.state.prices;

      prices = (0, _reactAddonsUpdate2.default)(prices, {
        $push: [{
          value: null,
          description: null
        }]
      });

      this.setState({ prices: prices });
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      var _this2 = this;

      this.setState({
        type: this.state.original_type
      }, function () {
        _this2.refs.boxPopover.hide();
      });
    }
  }, {
    key: 'handleChangeTicketUrl',
    value: function handleChangeTicketUrl(event) {
      this.setState({
        ticketUrl: event.target.value
      });
    }
  }, {
    key: 'handleChangeNotes',
    value: function handleChangeNotes(event) {
      this.setState({
        notes: event.target.value
      });
    }
  }, {
    key: 'handleChangeCurrency',
    value: function handleChangeCurrency(currency) {
      this.setState({
        currency: currency,
        currencyLabel: _currencies2.default[currency] + ' (' + currency + ')'
      });
    }
  }, {
    key: 'handleChangePrice',
    value: function handleChangePrice(index, key, event) {
      var prices = this.state.prices.length ? this.state.prices : [PriceBox.priceModel()];
      prices = (0, _reactAddonsUpdate2.default)(prices, (0, _defineProperty3.default)({}, index, {
        $merge: (0, _defineProperty3.default)({}, key, event.target.value)
      }));

      this.setState({
        prices: prices
      });
    }
  }, {
    key: 'handleChangeTab',
    value: function handleChangeTab(value) {
      this.setState({
        type: value
      });
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      var ENTER = 13;
      var overlayOpen = this.state.overlayOpen;

      if (overlayOpen && event.keyCode === ENTER) {
        this.setState({ overlayOpen: false });
        this.refs.boxPopover.hide();
      }
    }
  }, {
    key: 'handleOK',
    value: function handleOK() {
      var _this3 = this;

      var onChange = this.props.onChange;
      var _state2 = this.state,
          currency = _state2.currency,
          notes = _state2.notes,
          ticketUrl = _state2.ticketUrl,
          type = _state2.type;
      var prices = this.state.prices;


      if (type === constants.FREE) {
        prices = [];
      } else if (type === constants.DONATION) {
        prices = prices.slice(0, 1);
      }

      this.setState({
        prices: prices,
        original_type: type
      }, function () {
        onChange(type, prices, currency, notes, ticketUrl);
        _this3.refs.boxPopover.hide();
      });
    }
  }, {
    key: 'handleRemovePrice',
    value: function handleRemovePrice(index) {
      var prices = this.state.prices;

      prices.splice(index, 1);

      this.setState({
        prices: prices
      });
    }
  }, {
    key: 'togglePopover',
    value: function togglePopover() {
      if (this.state.overlayOpen === true) {
        this.refs.boxPopover.hide();
        this.setState({ overlayOpen: false });
      } else {
        this.refs.boxPopover.show();
        this.setState({ overlayOpen: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          popoverContainer = _props.popoverContainer,
          notes = _props.notes,
          polyglot = _props.polyglot,
          ticketUrl = _props.ticketUrl;
      var type = this.state.type;

      var tabUI = this.getTabUIFor(type);

      var hasErrors = (0, _keys2.default)(errors).reduce(function (acc, k) {
        return acc || !!errors[k].length > 0;
      }, false);

      var boxUI = type === constants.NULL ? _react2.default.createElement(PriceBox.Empty, { polyglot: polyglot }) : _react2.default.createElement(PriceBox.HasPrice, {
        hasErrors: hasErrors,
        type: this.props.type,
        prices: this.props.prices,
        currency: this.props.currency,
        notes: this.props.notes,
        ticketUrl: this.props.ticketUrl,
        polyglot: polyglot
      });

      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          ref: 'boxPopover',
          trigger: 'click',
          placement: 'top',
          rootClose: true,
          container: popoverContainer,
          overlay: _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'priceBoxPopover', className: 'prices-box-popover' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  _reactRadioGroup.RadioGroup,
                  { name: 'type', selectedValue: type, onChange: this.handleChangeTab.bind(this) },
                  _react2.default.createElement(
                    'ul',
                    { className: 'nav nav-tabs' },
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement(_reactRadioGroup.Radio, { value: constants.FREE }),
                        ' ',
                        polyglot.t('events.priceBox.free')
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      { className: type === constants.FIXED ? 'active' : '' },
                      _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement(_reactRadioGroup.Radio, { value: constants.FIXED }),
                        ' ',
                        polyglot.t('events.priceBox.fixed')
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      { className: type === constants.DONATION ? 'active' : '' },
                      _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement(_reactRadioGroup.Radio, { value: constants.DONATION }),
                        ' ',
                        polyglot.t('events.priceBox.donation')
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                tabUI
              )
            ),
            type && _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'details' },
                  _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'notes' },
                      'Notes'
                    ),
                    _react2.default.createElement('input', { type: 'text', id: 'notes', ref: 'notes', defaultValue: notes, onChange: this.handleChangeNotes.bind(this), className: 'form-control' })
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.FormGroup,
                    {
                      controlId: 'ticketUrl',
                      validationState: (0, _validate.validate)('urlOrEmpty', this.state.ticketUrl, errors.ticket_url) },
                    _react2.default.createElement(
                      _reactBootstrap.ControlLabel,
                      null,
                      polyglot.t('events.priceBox.ticketingWebsite')
                    ),
                    _react2.default.createElement(_reactBootstrap.FormControl, {
                      defaultValue: ticketUrl,
                      onChange: this.handleChangeTicketUrl.bind(this) }),
                    _react2.default.createElement(
                      _reactBootstrap.HelpBlock,
                      null,
                      polyglot.t('events.priceBox.specifyProtocol')
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'popover-actions' },
                  _react2.default.createElement(
                    'div',
                    { className: 'buttons' },
                    _react2.default.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'btn btn-default btn-outline',
                        onClick: this.handleCancel.bind(this)
                      },
                      polyglot.t('button.cancel')
                    ),
                    '\xA0',
                    _react2.default.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'btn btn-primary',
                        onClick: this.handleOK.bind(this)
                      },
                      'OK'
                    )
                  )
                )
              )
            )
          )
        },
        boxUI
      );
    }
  }], [{
    key: 'priceModel',
    value: function priceModel() {
      return {
        id: null,
        value: null,
        description: null
      };
    }
  }, {
    key: 'DonationTabContent',
    value: function DonationTabContent(_ref2) {
      var prices = _ref2.prices,
          currency = _ref2.currency,
          handleChangePrice = _ref2.handleChangePrice,
          handleChangeCurrency = _ref2.handleChangeCurrency,
          polyglot = _ref2.polyglot;

      var price = prices.length ? prices[0] : PriceBox.priceModel();

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'div',
            { className: 'tab-active' },
            _react2.default.createElement(
              'div',
              { className: 'row prices-outer-container' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-7' },
                'Contribution sugg\xE9r\xE9e'
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-3' },
                _react2.default.createElement(
                  'div',
                  { className: 'input-group' },
                  _react2.default.createElement('input', {
                    type: 'number',
                    className: 'form-control',
                    placeholder: '',
                    step: '0.01',
                    min: '0',
                    onChange: handleChangePrice.bind(null, 0, 'value'),
                    value: price.value
                  }),
                  _react2.default.createElement(
                    'span',
                    { className: 'input-group-addon' },
                    '$'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row prices-outer-container' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 text-right' },
                _react2.default.createElement(_components.CurrencyDropdown, {
                  currency: currency,
                  onChange: handleChangeCurrency,
                  polyglot: polyglot
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'Empty',
    value: function Empty(_ref3) {
      var polyglot = _ref3.polyglot,
          onClick = _ref3.onClick;

      return _react2.default.createElement(
        'div',
        {
          className: 'dashed-box price-box empty',
          onClick: onClick
        },
        _react2.default.createElement('span', { className: 'icon-cg-price left-icon' }),
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('events.priceBox.title')
        )
      );
    }
  }, {
    key: 'FixedPriceRow',
    value: function FixedPriceRow(_ref4) {
      var index = _ref4.index,
          price = _ref4.price,
          priceLength = _ref4.priceLength,
          handleChangePrice = _ref4.handleChangePrice,
          handleRemovePrice = _ref4.handleRemovePrice;

      var showRemovePrice = (0, _classnames2.default)({
        btn: true,
        'btn-link': true,
        'row-delete': true,
        hidden: priceLength === 1
      });

      return _react2.default.createElement(
        'div',
        { className: 'row prices-outer-container' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement('input', {
              type: 'number',
              className: 'form-control',
              placeholder: '',
              step: '0.01',
              min: '0',
              onChange: handleChangePrice.bind(null, index, 'value'),
              value: price.value
            }),
            _react2.default.createElement(
              'span',
              { className: 'input-group-addon' },
              '$'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8' },
          _react2.default.createElement('input', {
            type: 'text',
            className: 'form-control',
            placeholder: 'Description (facultative)',
            onChange: handleChangePrice.bind(null, index, 'description'),
            value: price.description
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-1' },
          _react2.default.createElement('button', {
            type: 'button',
            className: showRemovePrice,
            onClick: handleRemovePrice.bind(null, index)
          })
        )
      );
    }
  }, {
    key: 'FixedTabContent',
    value: function FixedTabContent(_ref5) {
      var prices = _ref5.prices,
          currency = _ref5.currency,
          handleChangePrice = _ref5.handleChangePrice,
          handleRemovePrice = _ref5.handleRemovePrice,
          handleAddPrice = _ref5.handleAddPrice,
          handleChangeCurrency = _ref5.handleChangeCurrency,
          polyglot = _ref5.polyglot;

      var formattedPrices = prices.length ? prices : [PriceBox.priceModel()];
      var priceNodes = formattedPrices.map(function (price, index) {
        return _react2.default.createElement(PriceBox.FixedPriceRow, {
          key: 'prices-fixed-row-' + index,
          index: index,
          price: price,
          priceLength: prices.length,
          handleChangePrice: handleChangePrice,
          handleRemovePrice: handleRemovePrice
        });
      });

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'div',
            { className: 'tab-active' },
            priceNodes,
            _react2.default.createElement(
              'div',
              { className: 'row prices-outer-container' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-6' },
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'a',
                    { className: 'add-link', onClick: handleAddPrice },
                    _react2.default.createElement(
                      'span',
                      { className: 'plus' },
                      '+'
                    ),
                    ' ',
                    _react2.default.createElement(
                      'span',
                      null,
                      polyglot.t('events.priceBox.addPrice')
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-6 text-right' },
                _react2.default.createElement(_components.CurrencyDropdown, {
                  currency: currency,
                  onChange: handleChangeCurrency,
                  polyglot: polyglot
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'FreeTabContent',
    value: function FreeTabContent() {
      // No UI - It's free
      return _react2.default.createElement('span', null);
    }
  }, {
    key: 'HasPrice',
    value: function HasPrice(_ref6) {
      var hasErrors = _ref6.hasErrors,
          type = _ref6.type,
          prices = _ref6.prices,
          currency = _ref6.currency,
          notes = _ref6.notes,
          ticketUrl = _ref6.ticketUrl,
          polyglot = _ref6.polyglot,
          onClick = _ref6.onClick;

      var priceNodes = prices.map(function (price, index) {
        var description = type === 'DONATION' ? 'contribution suggérée' : price.description;
        return _react2.default.createElement(
          'p',
          { key: 'price-' + index },
          parseFloat(price.value).toFixed(2),
          ' ',
          '$',
          currency,
          description && ' (' + description + ')'
        );
      });

      return _react2.default.createElement(
        'div',
        {
          className: 'line-box event-content-box price-box has-price' + (hasErrors ? ' has-error' : ''),
          onClick: onClick
        },
        _react2.default.createElement(
          'h3',
          { className: 'box-header' },
          polyglot.t('events.priceBox.title')
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-content' },
          type && _react2.default.createElement(
            'p',
            null,
            polyglot.t('events.priceBox.' + type.toLowerCase())
          ),
          priceNodes,
          notes && _react2.default.createElement(
            'p',
            null,
            notes
          ),
          ticketUrl && _react2.default.createElement(
            'p',
            { className: 'ticket-url' },
            ticketUrl
          )
        )
      );
    }
  }]);
  return PriceBox;
}(_react.Component), _class.propTypes = {
  currency: _propTypes2.default.oneOf((0, _keys2.default)(_currencies2.default)),
  errors: _propTypes2.default.object.isRequired,
  notes: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  prices: _propTypes2.default.array,
  ticketUrl: _propTypes2.default.string,
  type: _propTypes2.default.oneOf((0, _lodash2.default)(constants))
}, _temp2);
exports.default = PriceBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/PriceBox.js
// module id = 2220
// module chunks = 0